
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slide-show-nice',
  templateUrl: './slide-show-nice.component.html',
  styleUrls: ['./slide-show-nice.component.css']
})
export class SlideShowNiceComponent implements OnInit {
  imageObject: any[] = []
  imageSize={width: '27%', height: '800px', space: 16}
  autoSlide = {interval: 5, stopOnHover: false}
  constructor() { }

  ngOnInit(): void {

  this.imageList().forEach(myImage => {
     let imageItem={}
     imageItem["image"]="/assets/images/landing-page/slider/framed_"+myImage+".png"
     imageItem["thumbImage"]="/assets/images/landing-page/slider/framed_"+myImage+".png"

    this.imageObject.push(imageItem)
  });
  }
  imageList(){
    return [1,2,3,4,5,6,7,8];
  }
}
